import styled from 'styled-components';

export const Wrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0 0 6% 0;

  @media screen and (max-width: 394px) {
    justify-content: space-between;
    width: 100%;
  }
`;
